/** Utility function that takes an HTML snippet from Sparkle and adds the content to a given HTMLElement on the DOM.
 * Importantly, it also extracts and appends any script tags to the body of the document.
 */
const applyHtmlSnippet = async (htmlSnippet: string, toElement: HTMLElement) => {
  const doc = new DOMParser().parseFromString(htmlSnippet, 'text/html');

  // Extract and remove scripts
  const scripts = Array.from(doc.getElementsByTagName('script'));
  scripts.forEach((script) => script.remove());

  // Update content
  toElement.innerHTML = doc.body.innerHTML;

  // Append scripts
  scripts.forEach((script) => {
    const newScript = document.createElement('script');
    script.getAttributeNames().forEach((attr) => {
      newScript.setAttribute(attr, script.getAttribute(attr) || String());
    });
    newScript.textContent = script.textContent;
    document.body.appendChild(newScript);
  });
};

const getSlug = (url: string): string => {
  const slug = url.split('/').pop() || '';
  return slug.split(/[?#]/)[0];
};

const getCanonicalUrl = (linkTag: string): string => {
  const pattern = /url=(['"])([^'"]+)\1/;
  const match = linkTag.match(pattern);
  return match ? match[2] : '';
};

const isEmptyOrWhiteSpace = (str: string): boolean => !str || /^\s*$/.test(str);

export const sparkleUtils = {
  applyHtmlSnippet,
  getSlug,
  getCanonicalUrl,
  isEmptyOrWhiteSpace,
};
